import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Global from 'models/Global';
import AgendaSidebarView from 'views/AgendaSidebarView';
import AgendaSessionsView from 'views/AgendaSessionsView';
import CalendarView from 'views/CalendarView';
import RenderedView from 'views/RenderedView';
import template from 'hbars!templates/agendaView';
import sessionListTemplate from 'hbars!templates/sessionList';
import agendaSidebarTemplate from 'hbars!templates/agendaSidebar';
import noScheduleTemplate from 'hbars!templates/noSchedule';

Handlebars.registerPartial('sessionList', sessionListTemplate);
Handlebars.registerPartial('agendaSidebar', agendaSidebarTemplate);

var AgendaView = RenderedView.extend({

    events: {
        'click .full-screen-btn': 'toggleFullScreen'
    },

    initialize: function(options) {
        _.bindAll(this, 'renderSessions');
        this.agendeSidebarView = new AgendaSidebarView({model: this.model});

        this.listenTo(this.model.get('agenda'), 'change:viewState', this.dayChanged);
        this.listenTo(this.model.get('agenda'), 'change:fullScreen', this.renderFullScreen);
    },

    remove: function() {
        this.agendeSidebarView && this.agendeSidebarView.remove();
        this.sessionsGroupView && this.sessionsGroupView.remove();

        return Backbone.View.prototype.remove.call(this);
    },

    renderSessions: function() {
        if (!this.model.get('currentDay')) {
            return;
        }

        var day = this.model.get('currentDay');
        var state = this.model.get('agenda').get('viewState');

        if (state === 'myView') {
            const sessions = this.model.get('currentDay').get('session');
            const hasFavs = sessions.find(session => session.get('markersData').addToCal);
            if (!hasFavs) {
                this.$('.sessions-group-holder').html(noScheduleTemplate());
                return;
            }
        }

        var collection = state === 'track' ? day.get('parsedSessionsTracks') : day.get('parsedSessions');
        var sessionsHolder = this.$('.sessions-group-holder');
        this.sessionsGroupView && this.sessionsGroupView.remove();
        sessionsHolder.empty();
        this.changeWrapperWidth(false);

        if (sessionsHolder.length > 0) {
            if (state == 'calendar') {
                this.sessionsGroupView = new CalendarView({
                    model: day
                });
                sessionsHolder.append('<div class="calendar-holder"></div>');
                this.sessionsGroupView.setElement(this.$('.calendar-holder')).render();

                this.changeWrapperWidth(true);
                return;
            } else {
                this.sessionsGroupView = new Backbone.CollectionView({
                    collection: collection,
                    selectable: false,
                    modelView: AgendaSessionsView,
                    modelViewOptions: {currentDay: this.model.get('currentDay')}
                });
            }

            this.sessionsGroupView.render();
            sessionsHolder.html(this.sessionsGroupView.$el);
            this.$('.sessions-group-wrapper').addClass('col-sm-offset-1');
        }
    },

    dayChanged: function() {
        var thisView = this;

        this.toggleTransition(function(){
            thisView.renderSessions();
        });
    },

    changeWrapperWidth: function(extend) {
        var wrapper = this.$('.sessions-group-wrapper');
        wrapper.toggleClass('col-sm-offset-1 col-sm-10', !extend);
        wrapper.toggleClass('col-sm-12', extend);
    },

    toggleFullScreen: function() {
        this.model.get('agenda').set('fullScreen', !this.model.get('agenda').get('fullScreen'));
    },

    renderFullScreen: function() {
        var fullscreen = this.model.get('agenda').get('fullScreen');
        this.$('.main-app-container').toggleClass('full-screen', fullscreen);
        this.$('.agenda-sidebar-holder').toggleClass('col-sm-2', fullscreen);
        this.$('.agenda-sidebar-holder').toggleClass('col-sm-3', !fullscreen);
        this.$('.agenda-main-container').toggleClass('col-sm-9 ', !fullscreen);
        this.$('.agenda-main-container').toggleClass('col-sm-10', fullscreen);

        if (fullscreen) {
            this.$('.full-screen-btn a').html('Minimize View');
        } else {
            this.$('.full-screen-btn a').html('Expand View');
        }

    },

    toggleTransition: function(callback) {
        var thisView = this;
        this.$('.sessions-group-wrapper').toggleClass('no-opacity', true);
        _.delay(function(){
            thisView.$('.sessions-group-wrapper').toggleClass('no-opacity', false);
            callback && callback();
        }, 500);
    },

    render: function() {
        RenderedView.prototype.render.call(this, template, {
            agenda: this.model.get('agenda') ? this.model.get('agenda').toJSON() : undefined,
            currentDay: this.model.get('currentDay') ? this.model.get('currentDay').toJSON() : undefined,
            daysCount: this.model.get('daysCount'),
            event: Global.get('event').toJSON(),
            isWidget: Global.get('isWidget'),
            joinRequired: Global.get('event').get('privacy') == 'private' && !Global.get('me').get('isJoined')
        });
        return this;
    },

    postRender: function() {
        this.agendeSidebarView.setElement(this.$('.agenda-sidebar-holder')).render();

        this.renderSessions();

        if (this.model.get('agenda').get('fullScreen')) {
            this.renderFullScreen();
        }

        return this;
    }
});

export default AgendaView;


